import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 15 14" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      d="M4.97 7.35a.5.5 0 0 1 0-.7l2.48-2.49c.2-.2.52-.2.71 0l2.49 2.49c.2.2.2.5 0 .7L8.16 9.84a.5.5 0 0 1-.7 0zm2.84.72L6.74 7 7.8 5.93 8.88 7z"
      clipRule="evenodd"
    ></path>
    <path
      fillRule="evenodd"
      d="M1.44 8.41a2 2 0 0 1 0-2.82L6.4.64a2 2 0 0 1 2.83 0l4.95 4.95a2 2 0 0 1 0 2.82l-4.95 4.95a2 2 0 0 1-2.83 0zM2.5 6.65 7.45 1.7c.2-.2.52-.2.71 0l4.95 4.95c.2.2.2.5 0 .7L8.16 12.3a.5.5 0 0 1-.7 0L2.5 7.35a.5.5 0 0 1 0-.7"
      clipRule="evenodd"
    ></path>
  </svg>
);

const MilestoneIcon = (props) => <Icon component={SVG} {...props} />;

export default MilestoneIcon;
